<!--<InfoBubble value="STERN.de" color="pink" isFilled:'true'></InfoBubble>-->
<template>
    <div class="infoBubble"
         :class="[color,{filled : isFilled, pointer: this.$listeners.click}]"
         @click="$emit('click')">
        {{value}}
        <slot></slot>
        <span v-if="icon" :class="[icon, 'icon']" :style="[{color: iconColor}, iconStyle]"
              @click="$emit('iconClick')" v-tooltip.top="iconHover"></span>
        <span v-if="!disabled" @click="deleteSelf" class="close icon-close" :style="{ color:  closeColor}"></span>
    </div>
</template>

<script>
    export default {
        name: "InfoBubble",
        data: function () {
            return {}
        },
        props: {
            value: [String, Number],
            color: {
                validator: function (value) {
                    // The value must match one of these strings
                    return ['pink', 'blue', 'red', 'white', 'grey', 'purple'].indexOf(value) !== -1
                },
                default: 'blue'
            },
            isFilled: {
                type: Boolean,
                default: true
            },
            icon: String,
            iconColor: String,
            iconStyle: [String, Object],
            iconHover: String,
            disabled: {
                type: Boolean,
                default: false
            },
            deletable: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            closeColor: function () {
                return this.isFilled ? "fff" : this.color;
            }
        },
        methods: {
            deleteSelf: function () {
                if (this.deletable) {
                    this.$emit("bubbleDeleted", this.value);
                    this.$destroy();
                    this.$el.parentNode.removeChild(this.$el);
                } else {
                    this.$emit("bubbleDeleted");
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    .infoBubble {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 100px;
        width: fit-content;
        padding: 1px 10px;
        font-size: 0.8em;
        margin: 0 5px 5px 0;
        border: 1px solid transparent;
        cursor: default;
        position: relative;
    }

    .infoBubble img {
        height: 0.8em;
        margin-left: 5px;
    }

    .grey {
        color: #939BA2;
        border-color: #939BA2;
    }

    .pink {
        color: #d70364;
        border-color: #d70364;
    }

    .blue {
        color: #00b6ed;
        border-color: #00b6ed;
    }

    .purple {
        color: #752b77;
        border-color: #752b77;
    }

    .white {
        color: white;
        border-color: white;
    }

    .red {
        color: #8B0000;
        border-color: #8B0000;
    }

    .filled {
        color: white;
    }

    .filled.grey {
        background: #939BA2;
    }

    .filled.pink {
        background: #d70364;
    }

    .filled.blue {
        background: #00b6ed;
    }
    .filled.purple {
        background: #752b77;
    }

    .filled.red {
        background: #8B0000;
    }

    .filled.white {
        color: #394956;
        background: white;
    }

    .pointer {
        cursor: pointer;
    }

    .close {
        font-size: .5rem;
        margin-left: .4rem;
        cursor: pointer;
    }

    .icon {
        margin-left: .3rem;
    }
</style>